import type { MarketType } from '@ps/isp-web-services-types';

export const getIsTwoUpMarket = (
  marketType: MarketType | undefined
): marketType is 'FULL_TIME_RESULT_-_2_UP' => marketType === 'FULL_TIME_RESULT_-_2_UP';
